export default __webpack_public_path__ + "static/map-bdb39182c1ce610f655ee5a34be04f50.jpg";